import { Badge } from '@mantine/core';
import { STANJA_NAROCNINE } from './narocnina';

/** Značka stanja naročnine (zaslon Naročnina, skrbništvo). */
export function ZnackaNarocnine({ stanje }: { stanje?: string }) {
  const s = STANJA_NAROCNINE[stanje ?? ''];
  if (!s) {
    return null;
  }
  return (
    <Badge color={s.barva} variant={s.polno ? 'filled' : 'light'}>
      {s.oznaka}
    </Badge>
  );
}
